import { logInDevEnv } from "@one.com/react-common/functions";

export const removeVPS =
  (vpsProductId, globalCartLineIndex) =>
  async (dispatch, getState, { api }) =>
    api.removeVPS(vpsProductId).then(
      (isSuccess) => {
        isSuccess();

        // TODO: Verify whether we need to `pushRemoveFromCart` here:
        logInDevEnv(
          [
            "There was no implementation of GTM here before and it is unclear",
            "whether this was intentional or not. Please implement",
            "GTM.pushRemoveFromCart() when removing a VPS product from the",
            "cart if needed.",
          ].join(" "),
          { messagePrefix: "warning" },
        );
      },
      (err) => {
        console.error("Removing VPS product from the basket failed", err);
      },
    );
